import Nav from "./nav"
import Search from "./search"
import Form from "./form"
import Swiper from "./swiper"
import Home from "./home"
import DonationForm from "./donation-form"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Form(jQuery)
    Swiper(jQuery)
    Home(jQuery)
    DonationForm(jQuery)
})
